import { readLimitWait } from "../../src/lib/read-limit";
import type { ContentItem, ReadLimitPage } from "../server/content.server";
import { creatorPageHead, shellFrom, withStylesheet } from "./head";

/** A post's or library item's title, sharing picture, search rules and structured data. */
export function contentHead(
  matches: readonly { loaderData?: unknown; routeId: string }[],
  item: ContentItem | ReadLimitPage | undefined,
  pathname: string,
  stylesheet: string,
) {
  const shell = shellFrom(matches);
  if (!shell || !item) return {};
  // A read over the member's limit names nothing of the post it stands in for.
  if ("kind" in item)
    return withStylesheet(
      creatorPageHead(shell, {
        pathname,
        title: `Try again in ${readLimitWait(item.retryAfter)} | ${shell.creator.name}`,
        description: "This account opened a lot of posts very quickly.",
        noindex: true,
      }),
      stylesheet,
    );
  const head = creatorPageHead(shell, {
    pathname,
    title: item.head.title,
    description: item.head.description,
    canonicalPath: item.head.canonicalPath,
    canonicalOverride: item.head.canonical ?? undefined,
    noindex: item.head.noindex,
    image: item.head.image,
    article: true,
    structuredData: item.head.structuredData,
  });
  return withStylesheet(head, stylesheet);
}
